import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=0fe89946&scoped=true&"
import script from "./CreateEvent.vue?vue&type=script&lang=ts&"
export * from "./CreateEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=0fe89946&lang=scss&scoped=true&"
import style1 from "./CreateEvent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe89946",
  null
  
)

export default component.exports